import { ContactsOutlined } from "@mui/icons-material";
import firebase from "firebase/compat/app";

import 'firebase/compat/auth';
import 'firebase/compat/database';

import moment from "moment-timezone";

const firebaseConfig = {
  apiKey: "AIzaSyB8I0ujyMxL832tWh4j69UdJy5q3Ym4Ujo",
  authDomain: "smart-lpg-system-86fbf.firebaseapp.com",
  databaseURL: "https://smart-lpg-system-86fbf-default-rtdb.firebaseio.com",
  projectId: "smart-lpg-system-86fbf",
  storageBucket: "smart-lpg-system-86fbf.appspot.com",
  messagingSenderId: "442289210379",
  appId: "1:442289210379:web:d93b7b98141aeb2cbe330e",
  measurementId: "G-WPQ1H44DV3"
};

const app = firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const db = app.database();

const googleProvider = new firebase.auth.GoogleAuthProvider();

const signInWithGoogle = async () => {
  try {
    const res = await auth.signInWithPopup(googleProvider);
    /*const user = res.user;
    const query = await db
      .collection("users")
      .where("uid", "==", user.uid)
      .get();
    if (query.docs.length === 0) {
      await db.collection("users").add({
        uid: user.uid,
        name: user.displayName,
        authProvider: "google",
        email: user.email,
      });
    }*/
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const signInWithEmailAndPassword = async (email, password) => {
  try {
    await auth.signInWithEmailAndPassword(email, password);
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const registerWithEmailAndPassword = async (name, email, password) => {
  try {
    const res = await auth.createUserWithEmailAndPassword(email, password);
    const user = res.user;
    await db.collection("users").add({
      uid: user.uid,
      name,
      authProvider: "local",
      email,
    });
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const sendPasswordResetEmail = async (email) => {
  try {
    await auth.sendPasswordResetEmail(email);
    alert("Password reset link sent!");
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logout = () => {
  auth.signOut();
};

const firebase_get_device_logs = async (deviceId) => {
  var returnLogs = [];
  await db.ref("device_logs").child(deviceId).orderByKey().once("value", snapshot => {
    snapshot.forEach(year => {
      var item = {};
      //item.month = year.val();
      item.value = year.key;
      item.label = year.key;
      item.children = [];
      item.data = year.val();
      //console.log(year.val());
      for (const month in year.val()) {

        if (year.val().hasOwnProperty(month)) {    
          var em = [];
          switch(month)
          {
            case "01": 
              em.value = year.key + "01";
              em.label = "Jan";
              item.children.push(em);
              break;
            case "02": 
              em.value = year.key + "02";
              em.label = "Feb";
              item.children.push(em);
              break;
            case "03": 
              em.value = year.key + "03";
              em.label = "Mar";
              item.children.push(em);
              break;
            case "04": 
              em.value = year.key + "04";
              em.label = "Apr";
              item.children.push(em);
              break;
            case "05":  
              em.value = year.key + "05";
              em.label = "May";
              item.children.push(em);
              break;
            case "06": 
              em.value = year.key + "06";
              em.label = "Jun";
              item.children.push(em);
              break;
            case "07": 
              em.value = year.key + "07";
              em.label = "Jul";
              item.children.push(em);
              break;
            case "08":
              em.value = year.key + "08";
              em.label = "Aug";
              item.children.push(em);
              break;
            case "09":
              em.value = year.key + "09";
              em.label = "Sep";
              item.children.push(em);
              break;
            case "10":
              em.value = year.key + "10";
              em.label = "Oct";
              item.children.push(em);
              break;
            case "11":
              em.value = year.key + "11"; 
              em.label = "Nov";
              item.children.push(em);
              break;
            case "12": 
              em.value = year.key + "12";
              em.label = "Dec";
              item.children.push(em);
              break;
          }    
        }
      }
      // last 3 months are to keep, the rest is to x
      returnLogs.push(item);
      
    })
  });
  return returnLogs;
}

const firebase_update_backup_logs = async (deviceId, data) => {
  return await db.ref("device_logs").child(deviceId).set(data);
}

const firebase_get_device_log = async (deviceId, startDate, endDate) => {
  const start_year = startDate.format("yyyy");
  const start_month = startDate.format("MM");
  const start_day = startDate.format("DD");
  const end_year = endDate.format("yyyy");
  const end_month = endDate.format("MM");
  const end_day = endDate.format("DD");
  console.log("Start Month :: " + start_month);
  console.log("Start day :: " + start_day);
  console.log("End month :: " + end_month);
  console.log("End day :: " + end_day);
  var chart_data = [];
  if(start_month == end_month)
  {
    // same month
    await db.ref("device_logs").child(deviceId).child(start_year).child(start_month).orderByKey().startAt(start_day).endAt(end_day).once("value", snapshot => {
      snapshot.forEach(day => {
        //console.log(day.key);
        chart_data.push({
            "\u2713": day.key,
            "y": day.val()
          });
      })
    });
  }
  else
  {
    await db.ref("device_logs").child(deviceId).child(start_year).orderByKey().startAt(start_month).endAt(end_month).once("value", snapshot => {
      snapshot.forEach(month => {
        console.log(month.key)
      })
    });
  }
  return chart_data;
}

const firebase_get_device_client_title = async (clientId) => {
  var clientTitle = "";
 await db.ref("clients").child(clientId).child("info").child('title').once('value', (snapshot) => {
    //console.log(snapshot.val());
    clientTitle = snapshot.val();
  }, (errorObject) => {
    console.log('Reading client info FAILED :: ' + errorObject.name);
  });
  return clientTitle;
}

const firebase_get_uid = async (email) => {
  var uid = "";
 await db.ref("system_management/users")
  .orderByChild("email")
  .equalTo(email)
  .limitToFirst(1)
  .once('value', (snapshot) => {
    if(snapshot.exists())
    {
      uid = Object.keys(snapshot.val())[0];
    }
  }, (errorObject) => {
    console.log('Reading uid info FAILED :: ' + errorObject.name);
  });
  console.log("UID :: " + uid);
  return uid;
}

const firebase_get_line_api_key = async (deviceId) => {
  var line_api_key = "";
  await db.ref("devices/" + deviceId + "/client/line_api_key")
  .once('value', (snapshot) => {
    if(snapshot.exists())
    {
      line_api_key = snapshot.val();
    }
  }, (errorObject) => {
    console.log('Reading LINE api key FAILED :: ' + errorObject.name);
  });
  console.log("LINE API Key :: " + line_api_key);
  return line_api_key;
}

const firebase_get_email_configuration = async (deviceId) => {
  var email_con = {};
  await db.ref("data_email/" + deviceId)
  .once('value', (snapshot) => {
    if(snapshot.exists())
    {
      email_con = snapshot.val();
    }
  }, (errorObject) => {
    console.log('Reading email configuration FAILED :: ' + errorObject.name);
  });

  console.log("Email Configuration :: ");
  console.log(email_con);
  return email_con;
}

const firebase_update_email_configuration = (key, data) => {
  if(data.hasOwnProperty('emails'))
  {
    //console.log(data.emails)
    var filtered = data.emails.filter(email => email)
    //console.log("Filtered :: ");
    //console.log(filtered);
    data.emails = filtered;
  }
  //console.log("Data.emails :: ");
  //console.log(data.emails);
  return db.ref("data_email").child(key).update(data);
};
 
const firebase_assign_device_to_client = async (deviceId, dtitle, prevClientId, clientId, title, username) => {
  // delete current client from device
  await db.ref("clients").child(prevClientId).child("devices").child(deviceId).remove().then(() => {
    // first update client in device node
    return db.ref("devices").child(deviceId).child("client").set(
      {
        "id": clientId,
        "line_api_key": "????",
        "title": title,
        "username": username,
      })
      .then(function(){
        console.log("Assign device[" + deviceId + "] to client[" + clientId + "] succeeds.");
        // then update device in client node
        db.ref("clients").child(clientId).child("devices").child(deviceId).set(
          {
            "active": "true",
            "enddate": "-",
            "location": "-",
            "shared": "false",
            "start_date": "-",
          })
          .then(function(){
            console.log("Add device to client succeeds.");
            return JSON.stringify({"status": true});      
          })
          .catch(function(error){
            console.log("Assign device to client FAILED with message :: " + error.message);
            return JSON.stringify({"status": false, "message": "Assign device to client FAILED with message :: " + error.message});
          });
        //
      })
      .catch(function(error){
        console.log("Assign client to device FAILED with message :: " + error.message);
        return JSON.stringify({"status": false, "message": "Assign client to device FAILED with message :: " + error.message});
      })
  });
  
}

const firebase_share_device_to_client = async (deviceId, clientId, clientTitle, clientUsername) => {
  // update client with shared device
  return db.ref("devices").child(deviceId).child("shares").child(clientId).set(
    {
      "title": clientTitle,
      "username": clientUsername,
    })
    .then(function(){
      console.log("Share device[" + deviceId + "] to client[" + clientId + "] succeeds.");
      // then update device in client node
      db.ref("clients").child(clientId).child("devices").child(deviceId).set(
        {
          "active": "true",
          "enddate": "-",
          "location": "-",
          "shared": "true",
          "start_date": "-",
        })
        .then(function(){
          console.log("Share device to client succeeds.");
          return JSON.stringify({"status": true});      
        })
        .catch(function(error){
          console.log("Share device to client FAILED with message :: " + error.message);
          return JSON.stringify({"status": false, "message": "Share device to client FAILED with message :: " + error.message});
        });
      //
    })
    .catch(function(error){
      console.log("Set client for shared device FAILED with message :: " + error.message);
      return JSON.stringify({"status": false, "message": "Set client for shared device FAILED with message :: " + error.message});
    })
}

const firebase_update_device = (key, data) => {
  return db.ref("devices").child(key).update(data);
};

const firebase_update_device_test = (key, data) => {
  return db.ref("devices_test").child(key).update(data);
};


const firebase_update_device_setting = (key, data) => {
  return db.ref("devices").child(key).set(data);
};

const firebase_update_device_status = (key, data) => {
  return db.ref("devices").child(key).child("status").update(data);
};

const firebase_update_device_gas_active= (key, data) => {
  return db.ref("devices").child(key).child("current_status").update(data);
};

const firebase_update_client_info = async (uid, data) => {
  //console.log(uid + " :: " + data)
  return await db.ref("clients/"+ uid + "/info").update(data);
}

const firebase_update_client = async (uid, data) => {
  //console.log(uid + " :: " + data)
  return await db.ref("clients/"+ uid).update(data);
}

const firebase_delete_client_address = async (uid) => {
  //console.log(uid + " :: " + data)
  return await db.ref("clients/"+ uid + "/info").update({
    desc: "",
    district: "",
    postcode: "",
    province: "",
    street: "",
    subdistrict: "",
  });
}

const firebase_update_user_info = (key, data) => {
  //console.log(key);
  db.ref("system_management").child("users").child(key)
    .once("value", function(snapshot){
      if(snapshot.exists())
      {
        return db.ref("system_management").child("users").child(key).update(data)
      }
    })
}

const firebase_create_new_client = async (data) => {
  //console.log(data.type)
  const newClient = db.ref("clients").push();
  await newClient.set(data)
    .then(() => {
      //console.log(newClient.key);
    })
  //return db.ref("client_test").child(uid).set(data);
  return newClient.key;
}

const firebase_create_new_user = (uid, data) => {
  return db.ref("system_management").child("users").child(uid).set(data);
  //return db.ref("user_test").child("users").child(uid).set(data);
}

const firebase_create_new_device = async (data) => {
  //alert(data);
  var newDeviceRef = await db.ref('/devices').push();
  var nd = await newDeviceRef.set(data)
    .then(function(){
      //console.log("Create new device succeeds.")
      return JSON.stringify({"id": newDeviceRef.key, "status": true, "message": "Create new device succeeds."});      
    })
    .catch(function(error)
    {
      //console.log("Create new device FAILED with message :: " + error.message);
      return JSON.stringify({"status": false, "message": "Create new device FAILED with message :: " + error.message});
    });
  return nd;
}

const firebase_delete_device = async (uid) => {
  var d_result;
  await db.ref("devices").child(uid).once("value", function(snapshot){
    var device = JSON.parse(JSON.stringify(snapshot));
    console.log("Check client :: " + device.client.id);
    if(device.client.id != "????")
    {
      db.ref("clients").child(device.client.id).child("devices").child(uid).remove()
        .then(function(){
          console.log("Remove device [" + uid + "] from client [" + device.client.id + "] succeeded.");
          // then remove device from devices node
          db.ref("devices").child(uid).remove()
            .then(function(){
              console.log("Remove device [" + uid + "] succeeded.");
              return JSON.stringify({"status": true, "message": "Remove device [" + uid + "] succeeded."})
            })
            .catch(function(error){
              console.log("Remove device [" + uid + "] FAILED with error :: " + error.message);
              return JSON.stringify({"status": false, "message": "Remove device [" + uid + "] FAILED with error :: " + error.message})
            })
        })
        .catch(function(error){
          console.log("Remove device [" + uid + "] from client [" + device.client.id + "] FAILED with error :: " + error.message);
          return JSON.stringify({"status": false, "message": "Remove device [" + uid + "] from client [" + device.client.id + "] FAILED with error :: " + error.message})
        });
      }
    else
    {
      // then remove status first from devices node\\\\\\
      db.ref("devices").child(uid).remove()
      .then(function(){
        console.log("Remove device [" + uid + "] succeeded.");
        return JSON.stringify({"status": true, "message": "Remove device [" + uid + "] succeeded."})
      })
      .catch(function(error){
        console.log("Remove device [" + uid + "] FAILED with error :: " + error.message);
        return JSON.stringify({"status": false, "message": "Remove device [" + uid + "] FAILED with error :: " + error.message})
      })
    }
  })
}

const firebase_delete_client_from_device_shares = async (deviceId, clientId) => {
  var res;
  await db.ref("devices").child(deviceId).child("shares").child(clientId).remove()
  .then(function(){
    console.log("Remove client [" + clientId + "] from sharing device [" + deviceId + "] succeeded.");
    // then remove device from client node
    db.ref("clients").child(clientId).child("devices").child(deviceId).remove()
      .then(function(){
        console.log("Remove shared device [" + deviceId + "] succeeded.");
        res = true;
      })
      .catch(function(error){
        console.log("Remove shared device [" + deviceId + "] FAILED with error :: " + error.message);
        res = false;
      })
  })
  .catch(function(error){
    console.log("Remove client [" + clientId + "] from sharing device [" + deviceId + "] FAILED with error :: " + error.message);
    res = false;
  });
  return res;
}

const firebase_add_min_pressure_to_database = async () => {
  await db.ref("devices").orderByKey().once("value", snapshot => {
      snapshot.forEach(d => {
        var device = d.val();
        // for each device add min_value to pressure field if not exists!
        //console.log(d.key)
        if(!device.sensor_info.pressure.p1.hasOwnProperty("min_value"))
        {
          device.sensor_info.pressure.p1.min_value = "20"
        }
        if(!device.sensor_info.pressure.p2.hasOwnProperty("min_value"))
        {
          device.sensor_info.pressure.p2.min_value = "20"
        }
        if(!device.sensor_info.pressure.p3.hasOwnProperty("min_value"))
        {
          device.sensor_info.pressure.p3.min_value = "20"
        }
        // for each device add pressure_too_low to event field if not exists!
        if(!device.current_status.events.hasOwnProperty("pressure1_too_low"))
        {
          device.current_status.events.pressure1_too_low = "false"
        }
        if(!device.current_status.events.hasOwnProperty("pressure2_too_low"))
        {
          device.current_status.events.pressure2_too_low = "false"
        }
        if(!device.current_status.events.hasOwnProperty("pressure3_too_low"))
        {
          device.current_status.events.pressure3_too_low = "false"
        }

        // update to firebase
        db.ref("devices/"+ d.key + "/").update(device);
      });                                   
    }
  );
};

const firebase_add_vaporizer_to_database = async () => {
  await db.ref("devices").orderByKey().once("value", snapshot => {
      snapshot.forEach(d => {
        var device = d.val();
        // for each device add min_value to pressure field if not exists!
        //console.log(d.key)
        if(!device.current_status.hasOwnProperty("vaporizer"))
        {
          device.current_status.vaporizer = {
            fail_state : "true"
          }
        }
        
        // update to firebase
        db.ref("devices/"+ d.key + "/").update(device);
      });                                   
    }
  );
};

const firebase_add_vaporizer_sensor_info_to_database = async () => {
  await db.ref("devices").orderByKey().once("value", snapshot => {
      snapshot.forEach(d => {
        var device = d.val();
        // for each device add min_value to pressure field if not exists!
        //console.log(d.key)
        if(!device.sensor_info.hasOwnProperty("vaporizer"))
        {
          device.sensor_info.vaporizer = {
            desc: "Vaporizer description",
            hardware_status: "not_installed",
            title: "Vaporizer"
          }
        }
        
        // update to firebase
        db.ref("devices/"+ d.key + "/").update(device);
      });                                   
    }
  );
};

const firebase_add_gas_active_to_database = async () => {
  await db.ref("devices").orderByKey().once("value", snapshot => {
      snapshot.forEach(d => {
        var device = d.val();
        // for each device add min_value to pressure field if not exists!
        //console.log(d.key)
        if(!device.current_status.hasOwnProperty("gas_active"))
        {
          device.current_status.gas_active = "OFF";
        }
        
        // update to firebase
        db.ref("devices/"+ d.key + "/").update(device);
      });                                   
    }
  );  
};

const firebase_add_gas_leakage_count_to_database = async () => {
  await db.ref("devices").orderByKey().once("value", snapshot => {
      snapshot.forEach(d => {
        var device = d.val();
        // for each device add min_value to pressure field if not exists!
        //console.log(d.key)
        if(!device.current_status.events.hasOwnProperty("gas_leak_count"))
        {
          device.current_status.events.gas_leak_count = "0";
        }
        
        // update to firebase
        db.ref("devices/"+ d.key + "/").update(device);
      });                                   
    }
  );  
};

const firebase_add_device_management_to_database = async () => {
  await db.ref("devices").orderByKey().once("value", snapshot => {
      snapshot.forEach(d => {
        var device = d.val();
        // for each device add min_value to pressure field if not exists!
        //console.log(d.key)
        if(!device.hasOwnProperty("management"))
        {
          device.management = {
            "installation_date": moment().toISOString(),
            "due_date": moment().toISOString(),
            "payment_date": moment().toISOString(),
            "note": "make a note here"
          };
        }
        
        // update to firebase
        db.ref("devices/"+ d.key + "/").update(device);
      });                                   
    }
  );  
};

const firebase_update_device_management = (key, data) => {
  console.log(key);
  db.ref("devices").child(key)
    .once("value", function(snapshot){
      if(snapshot.exists())
      {
        return db.ref("devices").child(key).child("management").update(data)
      }
    })
}

const firebase_delete_gas_active_command_from_database = async (deviceId) => {
  await db.ref("devices").orderByKey().once("value", snapshot => {
    snapshot.forEach(d => {
      var device = d.val();
      // for each device add min_value to pressure field if not exists!
      //console.log(d.key)
      if(device.current_status.hasOwnProperty("gas_active_command"))
      {
        db.ref("devices/"+ d.key + "/current_status").child("gas_active_command").remove();
      }
      // update to firebase
    });                                   
  }
);  
};

export {
  auth,
  db,
  signInWithGoogle,
  signInWithEmailAndPassword,
  registerWithEmailAndPassword,
  sendPasswordResetEmail,
  logout,
  firebase_get_uid,
  firebase_get_device_log,
  firebase_get_device_logs,
  firebase_update_backup_logs,
  firebase_get_line_api_key,
  firebase_share_device_to_client,
  firebase_assign_device_to_client,
  firebase_get_device_client_title,
  firebase_update_device,
  firebase_update_device_status,
  firebase_update_device_setting,
  firebase_update_device_test,
  firebase_update_client_info,
  firebase_update_client,
  firebase_update_device_gas_active,
  firebase_delete_client_address,
  firebase_update_user_info,
  firebase_create_new_device,
  firebase_create_new_client,
  firebase_create_new_user,
  firebase_delete_device,
  firebase_delete_client_from_device_shares,
  firebase_add_min_pressure_to_database,
  firebase_add_vaporizer_to_database,
  firebase_add_vaporizer_sensor_info_to_database,
  firebase_add_gas_active_to_database,
  firebase_add_gas_leakage_count_to_database,
  firebase_add_device_management_to_database,
  firebase_update_device_management,
  firebase_delete_gas_active_command_from_database,
  firebase_get_email_configuration,
  firebase_update_email_configuration,
};